import React, { Component } from 'react';

class SkincareJourney extends Component {
	render() {
		return (
			<section className="assessment bg  skin__concerns skincare__journey">
				<div className="container-fluid">
					<h1 className="assessment__heading">How’s your skincare journey been?</h1>
					<div className="name__age--badges">
						<span>Trial and error</span>
						<span>Overwhelming</span>
						<span>Easy!</span>
						<span>Just Starting</span>
						<span>Still figuring it out!</span>
					</div>
				</div>
			</section>
		);
	}
}


export default SkincareJourney;